import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/site";

export const WhatsAppButton = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noreferrer"
    aria-label="Chat on WhatsApp"
    data-testid="whatsapp-float-btn"
    className="fixed bottom-24 right-6 z-[60] flex h-14 w-14 items-center justify-center bg-[#25D366] text-black shadow-[0_0_40px_rgba(37,211,102,0.3)] transition-transform duration-200 hover:scale-105"
  >
    <MessageCircle size={24} />
  </a>
);
